export default __webpack_public_path__ + "4a2c4c90960e7505944d88f82095e1b0.png";